import { Injectable } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { CultureKeyType, REGEX_PASSWORD } from '@constants/app.constants';
import { EMAIL_REGEX, NAME_REGEX } from '@constants/form.constants';
import { SignUpFormConfig } from '@models/form/form.models';
import { GenderResource } from '@models/resources/gender.model';
import {
  dateValidator,
  isInListValidator,
  mustMatchValidator,
} from '@utils/form-utils';
import { lte } from '@utils/func-utils';
import { FormConfigService } from '../form-config.service';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class SignUpFormConfigService
  implements FormConfigService<SignUpFormConfig, null>
{
  handleConfigDataChanges(
    _dataChanges: null,
    _formGroup: FormGroup<SignUpFormConfig>,
  ): void {
    throw new Error('Method not implemented.');
  }

  createFormConfig({
    genders,
    culture,
  }: {
    genders: GenderResource[];
    culture: CultureKeyType;
  }): SignUpFormConfig {
    return {
      birthDate: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          dateValidator({
            comparator: lte,
            dateToCompareTo: DateTime.now().minus({ years: 14 }).toJSDate(),
            culture,
          }),
        ],
      }),
      firstName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.pattern(NAME_REGEX)],
      }),
      lastName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.pattern(NAME_REGEX)],
      }),
      email: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.pattern(EMAIL_REGEX),
          mustMatchValidator('confirmEmail', true),
        ],
      }),
      confirmEmail: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.pattern(EMAIL_REGEX),
          mustMatchValidator('email'),
        ],
      }),
      phoneCountryCode: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      phoneNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      password: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16),
          mustMatchValidator('confirmPassword', true),
          Validators.pattern(REGEX_PASSWORD),
        ],
      }),
      confirmPassword: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, mustMatchValidator('password')],
      }),
      gender: new FormControl<number | null>(null, [
        Validators.required,
        isInListValidator(
          genders.map((g) => g.code),
          true,
        ),
      ]),
      receiveMarketingNotifications: new FormControl(true, {
        nonNullable: true,
      }),
    };
  }
  createValidators(): ValidatorFn[] {
    return [];
  }
}
